import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ObjectRendererComponent } from '../../../workflow/renderer/object-renderer/object-renderer.component';
import {FormRenderConfig} from '../form-schema-renderer.component';

@Component({
	selector: 'app-card-style-object-renderer',
	templateUrl: './card-style-renderer-type-object.component.html',
	styleUrls: ['./card-style-renderer-type-object.component.scss']
})
export class CardStyleRendererObjectTypeComponent extends ObjectRendererComponent implements OnInit {
	@Input() formConfig: FormRenderConfig;
	@Input() schemaKey: string;
	@Output() valid: EventEmitter<boolean> = new EventEmitter();

	constructor() {
		super();
	}

	ngOnInit(): void {
	}

	setValid(input: unknown): void {
		this.valid.emit(!!input || !this.required);
	}
}
